export default "__VITE_ASSET__BKP9jvBY__"